import { Helmet } from "react-helmet";
import OffersBody from "../components/offers/OffersBody";
import PageHero from "../components/reusables/hero/PageHero";

export default function Offers() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/offers-and-discounts"
        />
        <meta
          name="description"
          content="Discover offers and latest discounts from NTUNA.COM on  our services of Website, Systems & App development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        
        <meta
          property="og:description"
          content="Discover offers and latest discounts from NTUNA.COM on  our services of Website, Systems & App development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        <meta
          property="og:title"
          content="NTUNA.COM - Offers and Discounts | Uganda"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM - Offers and Discounts | Uganda"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM - Offers and Discounts"
        />
        <meta
          name="twitter:description"
          content="Discover offers and latest discounts from NTUNA.COM on  our services of Website, Systems & App development, ICT Consultancy & Equipment Supply, Digital Marketing, CCTV & IT Security, and Networking."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />
        <title>NTUNA.COM - Offers and Discounts | Uganda</title>
      </Helmet>
      <PageHero
        classes="dark-bg"
        titleClasses="title uppercase ntuna-deep-blue"
        title="Offers and Discounts"
      />
      <OffersBody />
    </>
  );
}
